import * as React from 'react';

import {
  Button,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@mui/material';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { DateTime } from 'luxon';

import { AuditLog, FlightOperationNotificationVersion } from '../../core/api/clients';

interface FlightOperationNotificationVersionsTableRowProps {
  version: FlightOperationNotificationVersion | null | undefined;
  auditLogs: AuditLog[] | null | undefined;
  isLatestVersion: boolean;
  isSelectedVersion: boolean;
}

function FlightOperationNotificationVersionsTableRow({
  version,
  auditLogs,
  isLatestVersion,
  isSelectedVersion,
}: FlightOperationNotificationVersionsTableRowProps) {
  const [showExpander, setShowExpander] = React.useState<boolean>(false);
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (auditLogs !== null && auditLogs !== undefined) {
      setShowExpander(version?.versionNumber !== 1 && auditLogs.length > 0);
    }
  }, [auditLogs, version]);

  const handleExpandButtonClick = () => setIsExpanded((prevState) => !prevState);

  const handleViewVersionButtonClick = () => {
    if (version?.eventReportId !== undefined) {
      const { eventReportId, versionNumber } = version;
      const uri = `/form/flight-operation-notification/${eventReportId}/view?versionNumber=${versionNumber}`;

      window.open(uri, '_blank', 'width=1000, height=700');
    }
  };

  return (
    <React.Fragment>
      <TableRow selected={isSelectedVersion} key={version?.versionNumber}>
        <TableCell>
          {showExpander && (
            <IconButton onClick={handleExpandButtonClick}>
              {isExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell>{version?.versionNumber}</TableCell>
        <TableCell>{version?.createdBy}</TableCell>
        <TableCell>{DateTime.fromISO(`${version?.versionDate}`).toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)}</TableCell>
        <TableCell align="right">
          <Button disabled={isSelectedVersion} onClick={handleViewVersionButtonClick}>View Version</Button>
        </TableCell>
      </TableRow>
      {auditLogs !== null && auditLogs !== undefined && (
        <TableRow sx={{ backgroundColor: 'text.disabled' }}>
          <TableCell sx={{ paddingTop: 0, paddingBottom: 0 }} colSpan={5}>
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <TableContainer component={Paper} sx={{ marginTop: 2, marginBottom: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: '16%' }}>Field</TableCell>
                      <TableCell sx={{ width: '42%' }}>Before Value</TableCell>
                      <TableCell sx={{ width: '42%' }}>After Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {auditLogs.map((auditLog) => (
                      <TableRow key={auditLog.id}>
                        <TableCell sx={{ verticalAlign: 'top' }}>{auditLog.key}</TableCell>
                        <TableCell sx={{ verticalAlign: 'top' }}>{auditLog.originalValue}</TableCell>
                        <TableCell sx={{ verticalAlign: 'top' }}>{auditLog.newValue}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
}

export default FlightOperationNotificationVersionsTableRow;
